var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OnlineReading",on:{"click":_vm.toBuy}},[_c('img',{attrs:{"src":require("@/assets/img/qietu/buy.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }